(() => {
  'use strict';
  function init(root) {
    if (root.dataset.wwmReady) return;
    root.dataset.wwmReady = 'true';
    const form = root.querySelector('[data-wwm-form]');
    if (!form) return;
    const steps = [...form.querySelectorAll('[data-wwm-step]')];
    const error = form.querySelector('[data-wwm-error]');
    const submit = form.querySelector('[data-wwm-submit]');
    let current = 0, pending = false, lastFingerprint = '', requestId = '';
    // Keep answers in this page only. Never persist personal information in browser storage.
    const values = name => [...form.querySelectorAll(`input[name="${name}"]:checked`)].map(input => input.value);
    function showError(message, target) {
      error.textContent = message;
      error.hidden = false;
      if (target) target.focus();
    }
    function showStep(index) {
      current = index;
      steps.forEach((step, i) => {step.hidden = i !== index;});
      error.hidden = true;
      form.querySelector('[data-wwm-progress]').textContent = index ? 'Step 2 of 2 — Your story & interests' : 'Step 1 of 2 — About you';
      steps[index].querySelector('[data-wwm-step-heading]').focus();
    }
    function validate(index) {
      const controls = [...steps[index].querySelectorAll('input:not([name=website]), textarea, select')];
      for (const field of controls) {
        field.setCustomValidity('');
        if (field.required && field.type !== 'checkbox' && !field.value.trim()) field.setCustomValidity('Please fill in this field.');
        if (field.name === 'email' && field.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim())) field.setCustomValidity('Please enter a complete email address.');
        if (field.name === 'referrerInstagram' && field.value.trim() && !/^@?[A-Za-z0-9._]{1,120}$/.test(field.value.trim())) field.setCustomValidity('Please enter their Instagram @handle, without spaces or a full URL.');
        if (field.name === 'socialHandle' && field.value.trim()) {
          if (form.elements.socialPlatform.value === 'website') {
            try { const url = new URL(field.value.trim()); if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) throw new Error(); }
            catch { field.setCustomValidity('Please enter a full http:// or https:// website address.'); }
          } else if (!/^[\p{L}\p{N}_.-]{1,120}$/u.test(field.value.trim().replace(/^@/, ''))) {
            field.setCustomValidity('Please enter your account handle, such as @yourname, without spaces or a full URL.');
          }
        }
        if (!field.checkValidity()) {
          showError(field.validationMessage || 'Please complete the required fields.', field);
          field.reportValidity();
          return false;
        }
      }
      const group = index ? 'interests' : 'movements';
      if (!values(group).length) {
        showError(index ? 'Please choose at least one interest.' : 'Please choose at least one type of movement.', form.querySelector(`input[name="${group}"]`));
        return false;
      }
      return true;
    }
    function updateSocialField() {
      const website = form.elements.socialPlatform.value === 'website';
      const handle = form.elements.socialHandle;
      form.querySelector('[data-wwm-handle-label]').textContent = website ? 'Website address *' : 'Handle *';
      form.querySelector('[data-wwm-handle-help]').textContent = website ? 'Enter your full website address, starting with https://.' : 'Your account username, not your display name.';
      handle.type = website ? 'url' : 'text';
      handle.placeholder = website ? 'https://yourwebsite.com' : '@yourname';
      handle.maxLength = website ? 500 : 120;
      handle.setCustomValidity('');
    }
    form.elements.socialPlatform.addEventListener('change', updateSocialField);
    updateSocialField();
    form.addEventListener('input', event => {
      if (event.target.setCustomValidity) event.target.setCustomValidity('');
      if (['story', 'movementMoment'].includes(event.target.name)) form.querySelector(`[data-wwm-count="${event.target.name}"]`).textContent = `${event.target.value.length} / 800 characters`;
    });
    form.querySelector('[data-wwm-back]').addEventListener('click', () => {if (!pending) showStep(0);});
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending || !validate(current)) return;
      if (current === 0) {showStep(1); return;}
      if (!validate(0)) {showStep(0); validate(0); return;}
      const data = {
        name: form.elements.name.value.trim(), email: form.elements.email.value.trim(),
        country: form.elements.country.value.trim(), movements: values('movements'), interests: values('interests'),
        story: form.elements.story.value.trim(), movementMoment: form.elements.movementMoment.value.trim(), link: '',
        socialPlatform: form.elements.socialPlatform.value, socialHandle: form.elements.socialHandle.value.trim(),
        referrerInstagram: form.elements.referrerInstagram.value.trim(),
        adult: form.elements.adult.checked, consent: form.elements.consent.checked,
        website: form.elements.website.value
      };
      const fingerprint = JSON.stringify(data);
      if (fingerprint !== lastFingerprint) {
        requestId = crypto.randomUUID();
        lastFingerprint = fingerprint;
      }
      const endpoint = root.dataset.endpoint;
      if (!endpoint) {showError('Applications are temporarily unavailable. Please try again later or contact Formwynn.'); return;}
      pending = true;
      error.hidden = true;
      submit.disabled = true;
      submit.textContent = 'Sending…';
      form.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(endpoint, {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          credentials: 'omit', body: JSON.stringify({...data, requestId}), signal: controller.signal
        });
        const result = await response.json();
        if (!response.ok || result.ok !== true || typeof result.receiptId !== 'string' || !result.receiptId || !result.receivedAt) {
          const failure = new Error('Application not confirmed');
          failure.status = response.status;
          throw failure;
        }
        root.querySelector('[data-wwm-receipt]').textContent = result.receiptId;
        form.hidden = true;
        const success = root.querySelector('[data-wwm-success]');
        success.hidden = false;
        success.focus();
        success.scrollIntoView({block: 'start', behavior: 'auto'});
      } catch (err) {
        showError(err.status === 429 ? 'Too many attempts just now. Please wait a little and try again. Your answers are still here.' : 'We couldn’t confirm your application. Please try again. Your answers are still here, and retrying the same application won’t create a duplicate.');
      } finally {
        clearTimeout(timeout);
        pending = false;
        submit.disabled = false;
        submit.textContent = 'Send application ↗';
        form.removeAttribute('aria-busy');
      }
    });
    root.querySelector('[data-wwm-share]').addEventListener('click', async () => {
      const status = root.querySelector('[data-wwm-share-status]');
      const publicUrl = 'https://formwynn.com/pages/community';
      try { await navigator.clipboard.writeText(publicUrl); status.textContent = 'Link copied. Share it whenever you like.'; }
      catch { status.textContent = `You can share this link: ${publicUrl}`; }
    });
    // Reveal only after handlers are installed; a missing script must never send personal data via a default GET.
    form.hidden = false;
  }
  document.querySelectorAll('[data-wwm-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wwm-root]').forEach(init));
})();
